export const SUPPORTED_LOCALES = ["en", "es", "pt-BR"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "en";

const STORAGE_KEY = "auditflow-locale";

/** Priority: localStorage → browser language → 'en' */
export function detectLocale(): Locale {
    if (typeof window === "undefined") return DEFAULT_LOCALE;
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_LOCALES.includes(stored as Locale))
        return stored as Locale;
    const nav = navigator.language ?? "";
    if (nav.startsWith("pt")) return "pt-BR";
    if (nav.startsWith("es")) return "es";
    return DEFAULT_LOCALE;
}

export function persistLocale(locale: Locale): void {
    localStorage.setItem(STORAGE_KEY, locale);
}
